import React from 'react'
import styles from './AppSecondaryBtn.module.css'

type AppSecondaryBtnProps = {
  children: React.ReactNode
  onClick?: () => void
  className?: string
  ariaLabel?: string
  ariaDescribedby?: string
  ariaExpanded?: boolean
  ariaPressed?: boolean
  ariaHaspopup?: boolean | 'menu' | 'dialog' | 'listbox' | 'tree' | 'grid'
  tabIndex?: number
  role?: string
  disabled?: boolean
}

const AppSecondaryBtn: React.FC<AppSecondaryBtnProps> = ({
  children,
  onClick,
  className,
  ariaLabel,
  ariaDescribedby,
  ariaExpanded,
  ariaPressed,
  ariaHaspopup,
  tabIndex,
  role,
  disabled
}) => {
  const buttonClasses = `${styles.button} ${className || ''}`
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      aria-expanded={ariaExpanded}
      aria-pressed={ariaPressed}
      aria-haspopup={ariaHaspopup}
      tabIndex={tabIndex}
      role={role}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default AppSecondaryBtn
